<div class="policy-box" (click)="policyClicked()">
  <div class="policy-box-header">
    <div class="title">
      <div class="title-text">{{ policyModel.name }}</div>
    </div>
    <div class="policy-box-header-tools">
      <img
        *ngIf="!policyModel.isDefault && !reachedMaxNumberOfPolicies && canDuplicate"
        tooltip="Duplicate policy"
        src="assets/images/common/copy.svg"
        (click)="duplicatePolicyClicked($event)"
        matTooltip="Duplicate"
        matTooltipClass="tooltip-container"
        matTooltipPosition="above"
      />
      <img
        *ngIf="!policyModel.isDefault && canDelete"
        tooltip="Delete policy"
        src="assets/images/common/delete.svg"
        (click)="deletePolicyClicked($event)"
        matTooltip="Delete"
        matTooltipClass="tooltip-container"
        matTooltipPosition="above"
      />
    </div>
  </div>
  <div class="description" *ngIf="policyModel.description && policyModel.isDefault">
    {{ policyModel.description }}
  </div>
  <div class="dates-section">
    <div class="date">
      <div class="date-title">Created</div>
      <div class="text-limitation">
        On
        {{ this.policyModel.userActionTimeStamps.createdAt | date: 'mediumDate' }}
        by {{ policyModel.userActionTimeStamps.createdBy }}
      </div>
    </div>
    <div *ngIf="policyModel.userActionTimeStamps.modifiedAt" class="date">
      <div class="date-title">Modified</div>
      <div class="text-limitation">
        On
        {{ this.policyModel.userActionTimeStamps.modifiedAt | date: 'mediumDate' }}
        by {{ policyModel.userActionTimeStamps.modifiedBy }}
      </div>
    </div>
    <div class="type" *ngIf="!policyModel.isDefault">
      <div class="type-title">Type</div>
      <div>{{ policyModel.type }}</div>
    </div>
    <div class="associated-envs" *ngIf="!policyModel.isDefault && environments">
      <div class="date-title">Associated Environments</div>
      <div class="text-limitation">{{ environments[0] }}</div>
      <div
        class="more-envs"
        *ngIf="environments.length > 1"
        [matTooltip]="environmentsString"
        matTooltipClass="tooltip-container"
        matTooltipPosition="above"
      >
        <div class="more-envs-title">+{{ environments.length - 1 }}</div>
      </div>
    </div>
  </div>
</div>
